<template>
  <Dialog :visible="visible" @update:visible="$emit('update:visible', $event)" modal append-to="body"
          header="Configurações do atendimento" :style="{ width: '420px', maxWidth: 'calc(100vw - 32px)' }"
          :draggable="false" :dismissable-mask="!saving" :closable="!saving" :close-on-escape="!saving">
    <fieldset class="attendance-settings" :disabled="loading || saving">
      <legend>Posição dos dados do paciente</legend>
      <p>Escolha o lado em que o card aparece durante o atendimento.</p>
      <div class="attendance-settings__options">
        <label v-for="side in sides" :key="side.value" class="attendance-settings__option"
               :class="{ 'is-selected': modelValue === side.value }">
          <input type="radio" name="patient-data-side" :value="side.value" :checked="modelValue === side.value"
                 @change="$emit('update:modelValue', side.value)">
          <span class="attendance-settings__preview" :class="`is-${side.value}`" aria-hidden="true">
            <span class="attendance-settings__patient"></span><span class="attendance-settings__content"></span>
          </span>
          <span>{{ side.label }}</span>
        </label>
      </div>
    </fieldset>
    <p v-if="loading || saving" class="text-muted fs-7 mt-3 mb-0" role="status">{{ loading ? 'Carregando configuração…' : 'Salvando configuração…' }}</p>
    <div v-if="error" class="alert alert-danger mt-3 mb-0" role="alert">
      {{ error }}
      <button type="button" class="btn btn-sm btn-light mt-2" @click="$emit('retry')">Recarregar configuração</button>
    </div>
    <template #footer>
      <button type="button" class="btn btn-primary btn-sm" :disabled="saving" @click="$emit('update:visible', false)">Concluído</button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
  name: 'AttendanceSettingsDialog',
  components: { Dialog },
  props: {
    visible: Boolean,
    loading: Boolean,
    saving: Boolean,
    error: String,
    modelValue: { type: String, default: 'left' },
  },
  emits: ['update:visible', 'update:modelValue', 'retry'],
  data() {
    return { sides: [{ value: 'left', label: 'Esquerda' }, { value: 'right', label: 'Direita' }] };
  },
};
</script>

<style scoped>
.attendance-settings { border: 0; margin: 0; padding: 0; }
.attendance-settings legend { float: none; font-size: 14px; font-weight: 600; color: #302b38; }
.attendance-settings p, .attendance-settings small { color: #706b79; font-size: 12px; line-height: 1.5; }
.attendance-settings__options { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin: 16px 0; }
.attendance-settings__option { position: relative; display: flex; flex-direction: column; gap: 10px; padding: 14px; border: 1px solid #ddd9e2; border-radius: 10px; cursor: pointer; font-size: 13px; }
.attendance-settings__option.is-selected { border-color: #780f5a; background: #fcf6fa; color: #780f5a; }
.attendance-settings__option input { position: absolute; bottom: 16px; right: 14px; accent-color: #780f5a; }
.attendance-settings__option:focus-within { outline: 2px solid #ae79a0; outline-offset: 2px; }
.attendance-settings__preview { display: flex; gap: 5px; height: 56px; }
.attendance-settings__patient { width: 28%; border-radius: 4px; background: #b16c9e; }
.attendance-settings__content { flex: 1; border: 1px solid #e6e1e9; border-radius: 4px; background: #f0edf3; }
.attendance-settings__preview.is-right { flex-direction: row-reverse; }
</style>
